import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Calendar, Users, UserPlus } from 'lucide-react';
import { useContactModal } from '../contexts/ContactModalContext';

const Header = ({ scrollY }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { openContactModal } = useContactModal();
  const isScrolled = scrollY > 50;

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-lg' 
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <div className="w-14 h-14 rounded-full overflow-hidden flex items-center justify-center flex-shrink-0">
              <img 
                src="https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/tl7d7og3_TCCC_logo_jpg.jpg" 
                alt="TC Cheyres-Châbles Logo"
                className="w-full h-full object-cover transform group-hover:scale-110 transition-transform"
              />
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            <Link
              to="/"
              className={`px-2.5 py-2 rounded-lg transition-all hover:scale-105 text-sm whitespace-nowrap ${
                isScrolled
                  ? 'text-gray-700 hover:bg-gray-100'
                  : 'text-white hover:bg-white/10'
              }`}
            >
              HOME
            </Link>
            <div className="relative group">
              <span
                className={`px-2.5 py-2 rounded-lg transition-all hover:scale-105 text-sm cursor-pointer whitespace-nowrap ${
                  isScrolled
                    ? 'text-gray-700 hover:bg-gray-100'
                    : 'text-white hover:bg-white/10'
                }`}
              >
                CLUB
              </span>
              <div className="absolute left-0 mt-2 w-56 bg-white rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
                <Link
                  to="/club"
                  className="block px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-t-lg"
                >
                  Histoire du Club
                </Link>
                <Link
                  to="/comite"
                  className="block px-4 py-3 text-gray-700 hover:bg-gray-100"
                >
                  Comité et entraîneurs
                </Link>
                <Link
                  to="/location-clubhouse"
                  className="block px-4 py-3 text-gray-700 hover:bg-gray-100"
                >
                  Location du club-house
                </Link>
                <a
                  href="/Statuts_2025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-b-lg"
                >
                  Statuts
                </a>
              </div>
            </div>
            <div className="relative group">
              <span
                className={`px-2.5 py-2 rounded-lg transition-all hover:scale-105 text-sm cursor-pointer whitespace-nowrap ${
                  isScrolled
                    ? 'text-gray-700 hover:bg-gray-100'
                    : 'text-white hover:bg-white/10'
                }`}
              >
                INSTALLATIONS
              </span>
              <div className="absolute left-0 mt-2 w-56 bg-white rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
                <Link
                  to="/tennis"
                  className="block px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-t-lg"
                >
                  Tennis
                </Link>
                
                {/* Padel */}
                <Link
                  to="/padel"
                  className="block px-4 py-3 text-gray-700 hover:bg-gray-100"
                >
                  Padel
                </Link>
                
                <Link
                  to="/location-clubhouse"
                  className="block px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-b-lg"
                >
                  Location du club-house
                </Link>
              </div>
            </div>
            <div className="relative group">
              <span
                className={`px-2.5 py-2 rounded-lg transition-all hover:scale-105 text-sm cursor-pointer whitespace-nowrap ${
                  isScrolled
                    ? 'text-gray-700 hover:bg-gray-100'
                    : 'text-white hover:bg-white/10'
                }`}
              >
                COMPÉTITIONS
              </span>
              <div className="absolute left-0 mt-2 w-48 bg-white rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
                <Link
                  to="/interclubs"
                  className="block px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-t-lg"
                >
                  Interclubs Actifs
                </Link>
                <Link
                  to="/interclubs-juniors"
                  className="block px-4 py-3 text-gray-700 hover:bg-gray-100"
                >
                  Interclubs Juniors
                </Link>
                <Link
                  to="/team-challenge"
                  data-testid="header-desktop-team-challenge-link"
                  className="block px-4 py-3 text-gray-700 hover:bg-gray-100"
                >
                  Team Challenge
                </Link>
                <Link
                  to="/tournois"
                  className="block px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-b-lg"
                >
                  Tournois
                </Link>
              </div>
            </div>
            <Link
              to="/juniors"
              className={`px-2.5 py-2 rounded-lg transition-all hover:scale-105 text-sm whitespace-nowrap ${
                isScrolled
                  ? 'text-gray-700 hover:bg-gray-100'
                  : 'text-white hover:bg-white/10'
              }`}
            >
              COURS JUNIORS
            </Link>
            <Link
              to="/tarifs"
              className={`px-2.5 py-2 rounded-lg transition-all hover:scale-105 text-sm whitespace-nowrap ${
                isScrolled
                  ? 'text-gray-700 hover:bg-gray-100'
                  : 'text-white hover:bg-white/10'
              }`}
            >
              TARIFS
            </Link>
            <Link
              to="/evenements"
              className={`px-2.5 py-2 rounded-lg transition-all hover:scale-105 text-sm whitespace-nowrap ${
                isScrolled
                  ? 'text-gray-700 hover:bg-gray-100'
                  : 'text-white hover:bg-white/10'
              }`}
            >
              ÉVÉNEMENTS
            </Link>
            <Link
              to="/sponsors"
              className={`px-2.5 py-2 rounded-lg transition-all hover:scale-105 text-sm whitespace-nowrap ${
                isScrolled
                  ? 'text-gray-700 hover:bg-gray-100'
                  : 'text-white hover:bg-white/10'
              }`}
            >
              SPONSORS
            </Link>
            <button
              onClick={() => openContactModal()}
              className={`px-2.5 py-2 rounded-lg transition-all hover:scale-105 text-sm whitespace-nowrap ${
                isScrolled
                  ? 'text-gray-700 hover:bg-gray-100'
                  : 'text-white hover:bg-white/10'
              }`}
            >
              CONTACT
            </button>
          </nav>

          {/* CTA Buttons - Desktop */}
          <div className="hidden lg:flex items-center space-x-2">
            <a
              href="http://tccheyres.plugin.ch/user/dashboard"
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-all hover:scale-105 text-sm font-semibold"
            >
              RÉSERVATIONS
            </a>
            <a
              href="http://tccheyres.plugin.ch/user/signup"
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-all hover:scale-105 text-sm font-semibold"
            >
              DEVENIR MEMBRE
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`lg:hidden p-2 rounded-lg transition-colors ${
              isScrolled
                ? 'text-gray-900 hover:bg-gray-100'
                : 'text-white hover:bg-white/10'
            }`}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white rounded-b-2xl shadow-xl max-h-[calc(100vh-5rem)] overflow-y-auto">
            <nav className="flex flex-col space-y-2 py-4 px-2">
              <Link
                to="/"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                HOME
              </Link>
              <div className="px-4 py-2 text-gray-900 font-semibold text-sm">
                CLUB
              </div>
              <Link
                to="/club"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors pl-8"
                onClick={() => setMobileMenuOpen(false)}
              >
                ↳ Histoire du Club
              </Link>
              <Link
                to="/comite"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors pl-8"
                onClick={() => setMobileMenuOpen(false)}
              >
                ↳ Comité et entraîneurs
              </Link>
              <Link
                to="/location-clubhouse"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors pl-8"
                onClick={() => setMobileMenuOpen(false)}
              >
                ↳ Location du club-house
              </Link>
              <a
                href="/Statuts_2025.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors pl-8"
                onClick={() => setMobileMenuOpen(false)}
              >
                ↳ Statuts
              </a>
              <div className="px-4 py-2 text-gray-900 font-semibold text-sm">
                INSTALLATIONS
              </div>
              <Link
                to="/tennis"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors pl-8"
                onClick={() => setMobileMenuOpen(false)}
              >
                ↳ Tennis
              </Link>
              <Link
                to="/padel"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors pl-8"
                onClick={() => setMobileMenuOpen(false)}
              >
                ↳ Padel
              </Link>
              <Link
                to="/location-clubhouse"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors pl-8"
                onClick={() => setMobileMenuOpen(false)}
              >
                ↳ Location du club-house
              </Link>
              <a
                href="/Statuts_2025.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors pl-8"
                onClick={() => setMobileMenuOpen(false)}
              >
                ↳ Statuts
              </a>
              <div className="px-4 py-2 text-gray-900 font-semibold text-sm">
                COMPÉTITIONS
              </div>
              <Link
                to="/interclubs"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors pl-8"
                onClick={() => setMobileMenuOpen(false)}
              >
                ↳ Interclubs Actifs
              </Link>
              <Link
                to="/interclubs-juniors"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors pl-8"
                onClick={() => setMobileMenuOpen(false)}
              >
                ↳ Interclubs Juniors
              </Link>
              <Link
                to="/team-challenge"
                data-testid="header-mobile-team-challenge-link"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors pl-8"
                onClick={() => setMobileMenuOpen(false)}
              >
                ↳ Team Challenge
              </Link>
              <Link
                to="/tournois"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors pl-8"
                onClick={() => setMobileMenuOpen(false)}
              >
                ↳ Tournois
              </Link>
              <Link
                to="/juniors"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                COURS JUNIORS
              </Link>
              <Link
                to="/tarifs"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                TARIFS
              </Link>
              <Link
                to="/evenements"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                ÉVÉNEMENTS
              </Link>
              <Link
                to="/sponsors"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                SPONSORS
              </Link>
              <button
                onClick={() => {
                  openContactModal();
                  setMobileMenuOpen(false);
                }}
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors text-left"
              >
                CONTACT
              </button>
              
              <div className="pt-4 space-y-2">
                <a
                  href="http://tccheyres.plugin.ch/user/dashboard"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block px-4 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors text-center font-semibold"
                >
                  RÉSERVATIONS
                </a>
                <a
                  href="http://tccheyres.plugin.ch/user/signup"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block px-4 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors text-center font-semibold"
                >
                  DEVENIR MEMBRE
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;